import React from 'react';
import PropTypes from 'prop-types';

import { delayedToggleClassWhenItemsInViewport } from '../../utils/helpers/viewport';

import Svg from '../../common/components/Svg';

import styles from './usps.scss';

import checkMarkSvg from '../../common/assets/icons/check-mark.svg';

class Usps extends React.Component {
  constructor(props) {
    super(props);

    this.$usps = [];

    if (typeof window !== 'undefined' && window.setInterval) {
      this.interval = window.setInterval(() => {
        window.requestAnimationFrame(
          delayedToggleClassWhenItemsInViewport(this.$usps, styles.visible, 100)
        );
      }, 250);
    }
  }

  componentWillUnmount() {
    this.$usps = [];
    if (typeof window !== 'undefined' && window.clearInterval) {
      window.clearInterval(this.interval);
    }
  }

  render() {
    return (
      <div
        className={`${styles.usps} ${this.props.dark ? styles.dark : null}`}
        style={{
          backgroundImage: this.props.background ? `url('${this.props.background}')` : null,
        }}
      >
        <div className={styles.container}>
          <h1 className={styles.headline}>{this.props.headline}</h1>

          {this.props.content ?
            <div className={styles.contentContainer}>
              <div className={styles.content}>
                {this.props.content}
              </div>
            </div>
          : null}

          <div className={styles.uspListContainer}>
            <ul className={styles.uspList}>
              {this.props.usps.map(usp => (
                <li key={usp} ref={c => this.$usps.push(c)}>
                  <Svg src={checkMarkSvg} className={styles.checkMark} />
                  <div className={styles.uspText}>{usp}</div>
                </li>
        ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

Usps.propTypes = {
  headline: PropTypes.string.isRequired,
  usps: PropTypes.arrayOf(PropTypes.string).isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  background: PropTypes.string,
  dark: PropTypes.bool,
};

Usps.defaultProps = {
  content: null,
  background: null,
  dark: false,
};

export default Usps;



// WEBPACK FOOTER //
// ./blocks/Usps/index.js